import { Grid, Typography } from "@mui/material";
import MainTitle from "../muiHome/mainTitle";

const SAHSResearch=()=>{
return (
<Grid container spacing={2}>
<Grid item xs={12}>
    <MainTitle title="School of Law" />
    </Grid>

    <Grid item xs={12}>
    <MainTitle title="Research & Development" />
    </Grid>

    <Grid item xs={12}>
    <Typography textAlign='left' fontSize="14px" letterSpacing="0.5px" fontFamily="sans-serif" >
    We consider research and development to be essential foundations of our academic and professional philosophy. The faculty at our institution actively arranges research conferences and seminars, creating a dynamic forum for specialists, students, and professors to share innovative ideas and achievements in the field of law.
    <br/><br/>
Our commitment lies in continuously fostering the development of our teachers, guaranteeing their up-to-date knowledge of the most recent socio legal, technological, and pedagogical advancements. Our school engages in active collaboration with prominent legal persons, leaders, and academic institutions to undertake joint goals. The primary objective is to foster creativity and provide practical resolutions to real-world legal challenges. Our goal is to create a dynamic atmosphere where collaboration fosters innovation and education has a meaningful impact on society and the legal sphere.
    
    </Typography>
    </Grid>
    <Grid item xs={12}>
    <div className="rdrow">
        <div className="row">
            <div className="col-md-12">
                <div className="text">
                    <div className="head">
                        <h3>Research & Development: Enhancement of Legal Research Infrastructure </h3>
                    </div>
                    <p>MVN University continually strives to strengthen its research ecosystem by providing advanced 
academic and research resources to its faculty members, research scholars, and students. In 
furtherance of this objective, the University has significantly enhanced its legal research 
infrastructure through the availability of reputed digital databases and comprehensive print 
resources. The University provides access to Manupatra, one of India’s leading legal research 
platforms, with approximately 12 active user licenses, enabling seamless access to case laws, 
statutes, notifications, legal commentaries, and national as well as international judgments. </p>
<p>In addition to digital resources, the University has also issued AIR (All India Reporter) 
software and hardbound print journals, which serve as authoritative references for legal 
research and citation. These resources support doctrinal research, case analysis, and 
comparative legal studies, thereby strengthening the quality of academic output. The Library is 
further enriched with an extensive collection of approximately 5,500 law books, authored by 
renowned and leading legal scholars, jurists, and subject experts. The collection spans core 
areas of law as well as emerging and interdisciplinary domains.</p>
<p>The integration of both online research tools and traditional print resources ensures 
comprehensive research support and encourages scholarly publications, research projects, and 
advanced legal studies. These initiatives reflect the University’s sustained commitment to 
academic excellence, innovation, and the promotion of a robust research culture. </p>
                </div>
            </div>
        </div>
        <div className="row">
            <div className="col-md-4 col-sm-4 col-xs-12">
                <div className="imgs">
                    <img src="/assets/img/researchimg-1.jpg" />
                </div>
            </div>
            <div className="col-md-4 col-sm-4 col-xs-12">
                <div className="imgs">
                    <img src="/assets/img/researchimg-2.jpg" />
                </div>
            </div>
            <div className="col-md-4 col-sm-4 col-xs-12">
                <div className="imgs">
                    <img src="/assets/img/researchimg-3.jpg" />
                </div>
            </div>
        </div>
    </div>
    </Grid>
    </Grid>

)
}
export default SAHSResearch;